"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var attachAttributionParams_1 = __importDefault(require("./middleware/attachAttributionParams"));
var attachWindowParams_1 = __importDefault(require("./middleware/attachWindowParams"));
var createMaybeAddUserAndIdentityId_1 = __importDefault(require("./middleware/createMaybeAddUserAndIdentityId"));
var createTrackingFunctions_1 = __importDefault(require("./createTrackingFunctions"));
var environmentParams_1 = __importDefault(require("./middleware/environmentParams"));
var eventDebugger_1 = __importDefault(require("./middleware/eventDebugger"));
var sendToBackend_1 = __importDefault(require("./middleware/sendToBackend"));
var sendToGA_1 = __importDefault(require("./middleware/sendToGA"));
var utmParams_1 = __importDefault(require("./middleware/utmParams"));
var trackingScope_1 = require("./trackingScope");
var utils_1 = require("./utils");
var createEventTracker = function (customMiddleware) {
    if (customMiddleware === void 0) { customMiddleware = []; }
    var middleware = (utils_1.isProduction()
        ? __spread([
            attachWindowParams_1.default,
            attachAttributionParams_1.default,
            utmParams_1.default,
            createMaybeAddUserAndIdentityId_1.default
        ], customMiddleware, [
            environmentParams_1.default,
            sendToBackend_1.default,
            sendToGA_1.default,
        ]) : __spread([
        attachWindowParams_1.default,
        attachAttributionParams_1.default,
        utmParams_1.default,
        createMaybeAddUserAndIdentityId_1.default
    ], customMiddleware, [
        environmentParams_1.default,
        eventDebugger_1.default,
    ])).map(function (ware) { return ware(trackingScope_1.trackingScopeApi); });
    console.warn('This package has been deprecated. We strongly encourage if you are ' +
        'planning to use it for the first time, please use the new library ' +
        'Events-Toolkit-Browser: https://github.com/zapier/events-toolkit-js');
    return createTrackingFunctions_1.default(function (eventName, metaData) { return __awaiter(void 0, void 0, void 0, function () {
        var context, isCancelled, setIsCancelled, applyContext, _deprecatedPropertiesInRoot, _deprecatedSetProprtiesInRoot, _deprecatedBuildProprtiesInRoot, buildEventApi, middleware_1, middleware_1_1, promise, event_1, e_1_1, e_2;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    context = {};
                    isCancelled = false;
                    setIsCancelled = function () {
                        isCancelled = true;
                    };
                    applyContext = function (newCtx) {
                        context = __assign(__assign({}, context), newCtx);
                    };
                    _deprecatedPropertiesInRoot = new Set();
                    _deprecatedSetProprtiesInRoot = function (properties) {
                        properties.forEach(function (property) {
                            _deprecatedPropertiesInRoot.add(property);
                        });
                    };
                    _deprecatedBuildProprtiesInRoot = function () {
                        var rootContext = {};
                        _deprecatedPropertiesInRoot.forEach(function (key) {
                            rootContext[key] = context[key];
                        });
                        return rootContext;
                    };
                    buildEventApi = function () { return ({
                        name: eventName,
                        data: __assign({}, metaData),
                        context: __assign({}, context),
                        apply: applyContext,
                        cancel: setIsCancelled,
                        _deprecatedSetProprtiesInRoot: _deprecatedSetProprtiesInRoot,
                        _deprecatedBuildProprtiesInRoot: _deprecatedBuildProprtiesInRoot,
                    }); };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 10, , 11]);
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 7, 8, 9]);
                    middleware_1 = __values(middleware), middleware_1_1 = middleware_1.next();
                    _b.label = 3;
                case 3:
                    if (!!middleware_1_1.done) return [3 /*break*/, 6];
                    promise = middleware_1_1.value;
                    event_1 = buildEventApi();
                    return [4 /*yield*/, promise(event_1)];
                case 4:
                    _b.sent();
                    if (isCancelled) {
                        return [3 /*break*/, 6];
                    }
                    _b.label = 5;
                case 5:
                    middleware_1_1 = middleware_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (middleware_1_1 && !middleware_1_1.done && (_a = middleware_1.return)) _a.call(middleware_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9: return [3 /*break*/, 11];
                case 10:
                    e_2 = _b.sent();
                    if (utils_1.isProduction()) {
                        console.warn(JSON.stringify({
                            message: 'Unable to track event: ',
                            eventName: eventName,
                            data: metaData,
                            context: context,
                        }), e_2);
                    }
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); });
};
exports.default = createEventTracker;
